import React, {useEffect, useState} from 'react';
import {Container, Row, Col} from 'reactstrap';
import CheckBox from '../../../Shared/CheckBox/Checkbox';
import BasicText from '../DebtPaymentComponents/basicText';
import CustomerEmail from '../../SaleBlock/CustomerEmail/CustomerEmail';
import {isMobile} from 'react-device-detect';

const EmailCheck = (props) => {
  function handleCustomerEmailValidate(valid) {
    return true;
  }

  return (
    <>
      <Row className='email-checkbox'>
        <Col xs='1'>
          <CheckBox
            id='agreement'
            onCheck={(e) => props.handleCheckBox()}
            onUncheck={(e) => props.handleCheckBox()}
            checked={props.checked}></CheckBox>
        </Col>
        <Col xs='10' className={isMobile ? 'pl-0' : ''}>
          <BasicText text='אני רוצה לקבל את אישור התשלום במייל' />
        </Col>
      </Row>

      {props.checked && (
        <div className='email-input'>
          <CustomerEmail
            customerEmail={{email: '', ban: '', id: ''}}
            onValid={handleCustomerEmailValidate}
            showInvoiceLabel={props.isPrivate}
          />
          {props.emailError ? <div className='email-error'>בטוח שברצונך לקבל אישור למייל? לא הזנת את הכתובת </div> : null}
        </div>
      )}
    </>
  );
};

export default EmailCheck;
